// extracted by mini-css-extract-plugin
module.exports = {"ctabox":"CTABox_ctabox__1GI7O","body":"CTABox_body__1LR2O","cta":"CTABox_cta__h9VmU"};